import { bootInboxEmbed, currentInboxScript } from "./inboxEmbed";

const bootScript = currentInboxScript();

function start(): void {
    bootInboxEmbed(bootScript);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
} else {
    start();
}
